import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, CardTitle } from "reactstrap"
import DonutChart from "./DonutChart"
import "c3/c3.css"

import { useSelector } from "react-redux"

// Takes `reviews` from the parent dashboard (which already has the
// freshly-synced list) instead of fetching its own copy - two independent
// fetches meant this widget only ever showed whatever existed when it first
// mounted, and never updated when "Sync Now" pulled in new reviews.
const ReviewsSummary = ({ reviews = [] }) => {
  const mode = useSelector(state => state.Layout.layoutMode)
  const [mostFrequentReviewer, setMostFrequentReviewer] = useState(null)

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      const reviewerCounts = {}
      const reviewerProfileUrls = {}

      reviews.forEach(review => {
        if (review.reviewBy) {
          reviewerCounts[review.reviewBy] =
            (reviewerCounts[review.reviewBy] || 0) + 1

          if (!reviewerProfileUrls[review.reviewBy]) {
            reviewerProfileUrls[review.reviewBy] = review.reviewerProfileUrl
          }
        }
      })

      const mostFrequent = Object.entries(reviewerCounts).reduce(
        (acc, [reviewer, count]) =>
          count > acc.count
            ? { reviewer, count, profileUrl: reviewerProfileUrls[reviewer] }
            : acc,
        { reviewer: null, count: 0, profileUrl: null },
      )

      setMostFrequentReviewer(mostFrequent)
    } else {
      setMostFrequentReviewer(null)
    }
  }, [reviews])

  return (
    <React.Fragment>
      <Card className="br">
        <CardBody>
          <CardTitle className="h4 mb-4">Google Reviews Summary</CardTitle>

          <Row className="text-center mt-4">
            <div className="col-12">
              {mostFrequentReviewer?.reviewer ? (
                <h5 className="font-size-20">
                  {mostFrequentReviewer.profileUrl ? (
                    <a
                      href={mostFrequentReviewer.profileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: mode === "dark" ? "#2990DF" : "#0066cc",
                      }}
                    >
                      {mostFrequentReviewer.reviewer}
                    </a>
                  ) : (
                    mostFrequentReviewer.reviewer
                  )}
                </h5>
              ) : (
                <h5 className="font-size-20">No Data</h5>
              )}
              <p className="text-muted">Most Frequent Reviewer</p>
            </div>
          </Row>

          <div dir="ltr">
            <DonutChart reviews={reviews} />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ReviewsSummary
